import { render, staticRenderFns } from "./planlist.vue?vue&type=template&id=37a7ad7a&scoped=true&"
import script from "./planlist.vue?vue&type=script&lang=js&"
export * from "./planlist.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=37a7ad7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a7ad7a",
  null
  
)

export default component.exports